import { render } from "./GeographyGuideline.vue?vue&type=template&id=21212743&scoped=true"
import script from "./GeographyGuideline.vue?vue&type=script&lang=js"
export * from "./GeographyGuideline.vue?vue&type=script&lang=js"

import "./GeographyGuideline.vue?vue&type=style&index=0&id=21212743&scoped=true&lang=css"

import exportComponent from "/var/www/html/bcsprostuti-web-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21212743"]])

export default __exports__